import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RatingProfile, ServiceDiscount, AccessorialDiscount, DIMDivisorOverride } from 'src/app/_models/models';
import { CommonService } from '../common.service';

@Injectable({
  providedIn: 'root'
})
export class RatingProfilesService {

  constructor(private common: CommonService, private client: HttpClient) {

  }

  getAll(name: string): Observable<any[]> {

    let url = this.common.getApiAddress();

    if (name == undefined || name == null) {
      url = url + "/RatingProfiles" ;
    } else {
      url = url + "/RatingProfiles?name=" + name ;
    }

    return this.client.get<RatingProfile[]>(url)
      .pipe(
        map<RatingProfile[], RatingProfile[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Get rating profiles failed", e);
        })
      );
  }

  get(id: number): Observable<any> {

    return this.client.get<RatingProfile[]>(this.common.getApiAddress() + "/RatingProfiles/" + id.toString())
      .pipe(
        map<any, any>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Get rating profile failed", e);
        })
      );
  }

  create(data: RatingProfile): Observable<RatingProfile> {
    return this.client.post<RatingProfile>(this.common.getApiAddress() + "/RatingProfiles", data)
      .pipe(
        map<RatingProfile, RatingProfile>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Create rating profile failed", e);
        })
      );
  }

  copy(id: number): Observable<RatingProfile> {
    return this.client.post<RatingProfile>(this.common.getApiAddress() + "/RatingProfiles/Copy?id=" + id.toString(), null)
      .pipe(
        map<RatingProfile, RatingProfile>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Copy rating profile failed", e);
        })
      );
  }

  update(data: RatingProfile): Observable<RatingProfile> {
    return this.client.put<RatingProfile>(this.common.getApiAddress() + "/RatingProfiles/" + data.id, data)
      .pipe(
        map<RatingProfile, RatingProfile>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Edit rating profile failed", e);
        })
      );
  }

  delete(id: number): Observable<RatingProfile> {
    return this.client.delete<RatingProfile>(this.common.getApiAddress() + "/RatingProfiles/" + id.toString())
      .pipe(
        map<RatingProfile, RatingProfile>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Delete failed", e);
        })
      );
  }

  mapRatingProfile(object: any): Observable<any> {
    return this.client.post<any>(this.common.getApiAddress() + "/clients/MapRatingProfilesForClient", object)
      .pipe(
        map<any[], any[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Map rating profile failed", e);
        })
      );
  }

  updateMappedRatingProfile(object: any): Observable<any> {
    return this.client.post<any>(this.common.getApiAddress() + "/clients/UpdateMapRatingProfilesForClient", object)
      .pipe(
        map<any[], any[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Update mapped rating profile failed", e);
        })
      );
  }

  deleteMappedRatingProfile(clientId?: number, ratingProfileId?: number): Observable<any[]> {

    let url = this.common.getApiAddress();


    url = url + "/clients/DeleteMappedRatingProfilsForClient?clientId=" + clientId + "&ratingProfileId=" + ratingProfileId;


    return this.client.delete<any[]>(url)
      .pipe(
        map<any[], any[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Remove carrier failed", e);
        })
      );
  }



  getServiceDiscounts(id: number, serviceCode: string, packaging: string) {
    var url = this.common.getApiAddress() + "/RatingProfiles/GetServiceDiscounts?id=" + id.toString();
    if (serviceCode != null && serviceCode.length > 0)
      url += "&serviceCode=" + serviceCode;
    if (packaging != null && packaging.length > 0)
      url += "&packaging=" + packaging;
    return this.client.get<ServiceDiscount[]>(url)
      .pipe(
        map<any, any>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Get rating profile services failed", e);
        })
      );

  }
  saveServiceDiscount(data: any): Observable<ServiceDiscount> {
    return this.client.post<ServiceDiscount>(this.common.getApiAddress() + "/RatingProfiles/SaveServiceDiscount", data)
      .pipe(
        map<ServiceDiscount, ServiceDiscount>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Edit discount failed", e);
        })
      );
  }
  deleteServiceDiscount(id: number): Observable<ServiceDiscount> {
    return this.client.delete<ServiceDiscount>(this.common.getApiAddress() + "/RatingProfiles/DeleteServiceDiscount?id=" + id.toString())
      .pipe(
        map<ServiceDiscount, ServiceDiscount>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Delete failed", e);
        })
      );
  }

  saveAccessorialDiscount(data: any): Observable<AccessorialDiscount> {
    return this.client.post<AccessorialDiscount>(this.common.getApiAddress() + "/RatingProfiles/SaveAccessorialDiscount", data)
      .pipe(
        map<AccessorialDiscount, AccessorialDiscount>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Edit accessorial discount failed", e);
        })
      );
  }
  deleteAccessorialDiscount(id: number): Observable<AccessorialDiscount> {
    return this.client.delete<AccessorialDiscount>(this.common.getApiAddress() + "/RatingProfiles/DeleteAccessorialDiscount?id=" + id.toString())
      .pipe(
        map<AccessorialDiscount, AccessorialDiscount>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Delete failed", e);
        })
      );
  }

  saveDIMDivisor(data: any): Observable<DIMDivisorOverride> {
    return this.client.post<DIMDivisorOverride>(this.common.getApiAddress() + "/RatingProfiles/SaveDIMDivisor", data)
      .pipe(
        map<DIMDivisorOverride, DIMDivisorOverride>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Edit DIM divisor failed", e);
        })
      );
  }
  deleteDIMDivisor(id: number): Observable<DIMDivisorOverride> {
    return this.client.delete<DIMDivisorOverride>(this.common.getApiAddress() + "/RatingProfiles/DeleteDIMDivisor?id=" + id.toString())
      .pipe(
        map<DIMDivisorOverride, DIMDivisorOverride>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Delete failed", e);
        })
      );
  }

}
